import "assets/styles/teaser.scss";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Labels from "components/ui/Labels/Labels";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import { useView } from "features/view/context/ViewContext";
import GroupOwnerButtons from "features/groups/components/GroupOwnerButtons";
import { ReactComponent as GroupIcon } from "assets/images/icons/groups.svg";

function GroupTeaser({
                       nid,
                       name,
                       photo,
                       description,
                       distance,
                       participants,
                       isPrivate,
                       isOwner,
                       url,
                       teaserVariant,
                       labelVariant,
                       buttonVariant
                     }) {
  const history = useHistory();
  const { refresh } = useView();

  let labels = [
    isPrivate ? 'Besloten groep' : 'Open groep',
  ];
  if (distance) {
    labels.push(`${ distance > 1 ? Math.round(distance) : '< 1' } km`);
  }

  return (
    <div className={ `teaser ${ teaserVariant && 'teaser--' + teaserVariant }` }>
      <div className={ 'teaser__inner' }>
        <div className={ 'teaser__actions' }>
          <Labels items={ labels } variant={ labelVariant }/>
          <div className={ 'teaser__messages' }>

            <Button onClick={ () => history.push(url) } variant={ buttonVariant }>
              <GroupIcon/>
              { participants === 1 ? '1 deelnemer' : `${ participants } deelnemers` }
            </Button>

          </div>
        </div>

        <div className={ 'teaser__title' }>
          <h3 className={ 'pointer' } onClick={ () => history.push(url) }>{ name }</h3>
        </div>

        {
          photo &&
          <div className={ 'teaser__image' }>
            <ResponsiveImage value={ photo }/>
          </div>
        }

        <div className={ 'teaser__intro' }>
          { description }
        </div>

        <div className={ 'teaser__buttons' }>
          <Button onClick={ () => history.push(url) } variant={ 'secondary' } className={ 'button--small' }>
            Bekijk groep
          </Button>

          {
            isOwner &&
            <GroupOwnerButtons nid={ nid }
                               title={ name }
                               onDeleted={ refresh }
                               onEdited={ refresh }/>
          }
        </div>
      </div>
    </div>
  );
}

GroupTeaser.propTypes = {
  nid: PropTypes.number,
  name: PropTypes.string,
  photo: PropTypes.string,
  description: PropTypes.string,
  distance: PropTypes.string,
  participants: PropTypes.number,
  isPrivate: PropTypes.bool,
  url: PropTypes.string
}

export default GroupTeaser;
